import { Fragment, Suspense, lazy, useContext, useEffect } from 'react';
import { AuthContext } from '../context/LocalAuthContext';
import RouterOut from './out/RouterOut';
import ScrollToTop from '../hooks/useScrollToTop';
import UICookiesAlert from '../components/organisms/UICookiesAlert';
import UIFooter from '../components/organisms/UIFooter';
import UINavbarOut from '../components/organisms/UINavbarOut';
import { UseMouseInteractions } from '../hooks/useMouseInteractions';
import { getIP } from '../services/getIP';

const RouterIn = lazy(() => import('./in/RouterIn'));
const UINavbarIn = lazy(() => import('../components/organisms/UINavbarIn'));

export default function RouterMain() {
    const { auth } = useContext(AuthContext);
    useEffect(() => { UseMouseInteractions({}); getIP().then(res => localStorage.setItem("localeData", JSON.stringify(res))) }, [])
    return (
        <Fragment>
            <ScrollToTop />
            {auth !== null ? <UINavbarIn /> : <UINavbarOut />}
            {auth === null && <RouterOut />}
            {auth !== null && <Suspense fallback={<div></div>}> <RouterIn /> </Suspense>}
            <UICookiesAlert />
            <UIFooter />
        </Fragment>
    );
};
